/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContentTranslationResponseDto } from './contentTranslationResponseDto';

export interface ContentResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  translations: Array<ContentTranslationResponseDto>;
  isActive: boolean;
  version: number;
  type: ContentResponseDto.TypeEnum;
}
// tslint:disable-next-line:no-namespace
export namespace ContentResponseDto {
  export type TypeEnum = 'individual' | 'corporate';
  export const TypeEnum = {
      Individual: 'individual' as TypeEnum,
      Corporate: 'corporate' as TypeEnum,
  };
}
